<template>
  <div class="item-box-content">
    <div class="title-font-style">
      <span>盖章合同上传</span>
    </div>
    <div class="sealed-contract-uplaod">
      <el-upload
        :auto-upload="false"
        action="/"
        :http-request="allUpload"
        multiple
        :on-change="uploadFile"
        :show-file-list="false"
        style="width:100%;"
        class="upload-demo"
        drag
        ref="upload"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
        <div
          class="el-upload__tip"
          slot="tip"
        >支持上传pdf、jpg、png格式文件,单个文件大小不得超过10M，总文件大小不得超过200M（如单次上传多个文件，文件格式需一致）</div>
      </el-upload>
    </div>
    <div>
      <el-table
        border
        ref="goodsDetailTable"
        style="width: 100%"
        :data="list"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        element-loading-text="拼命加载中请稍后..."
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column prop="fileName" show-overflow-tooltip label="文件"></el-table-column>
        <el-table-column prop="createDate" show-overflow-tooltip label="上传时间">
          <template slot-scope="scope">{{scope.row.createDate|dateFilterL}}</template>
        </el-table-column>
        <el-table-column prop="pcName" show-overflow-tooltip label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="deletePic(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-row>
        <el-col :span="24" style="margin-top:20px">
          <el-button :disabled="list.length === 0" type="primary" @click="onContractContrast">合同对比</el-button>
        </el-col>
      </el-row>
    </div>
    <!-------------- 二次确认 -------------->
    <open-or-close-dialog
      ref="openOrCloseRefs"
      @onUpdataState="onUpdataState"
      :title="title"
      :content="content"
    ></open-or-close-dialog>
  </div>
</template>
<script>
import OpenOrClose from '@/components/OpenOrClose/index' // 二次确认

import {
  addUpload,
  queryAllByContractUpload,
  deleteContractFile
} from '@/api/purchase/purchaseManage'
export default {
  components: {
    'open-or-close-dialog': OpenOrClose
  },
  data () {
    return {
      uploadFileType: ['pdf', 'png', 'jpg', 'jpeg'],
      fileList: {},
      fileListArr: [],
      list: [],
      bizId: '', // 合同Id
      contractType: '', // 销售1, 采购2
      content: '',
      title: ''
    }
  },
  methods: {
    uploadFile (file) {
      this.imgUrl = file.raw // 拿到文件的信息
      this.allUpload()
    },
    // 删除
    deletePic (row) {
      this.content = '确认删除此文件？'
      this.title = '删除文件'
      this.$refs.openOrCloseRefs.onInitial(row)
    },
    // 再次确认
    onUpdataState (row) {
      deleteContractFile(row.saId)
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success(res.data.msg)
            this.getList(this.bizId, this.contractType)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 列表
    getList (bizId, contractType, type) {
      this.type = type
      this.bizId = bizId
      this.contractType = contractType
      queryAllByContractUpload(this.bizId, this.contractType)
        .then((res) => {
          if (res.data.code === 200) {
            this.list = res.data.obj
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    async allUpload () {
      const formData = new FormData()
      formData.append('file', this.imgUrl)
      await addUpload(this.bizId, this.contractType, formData).then((res) => {
        if (res.data.code === 200) {
          this.$message.success('上传成功，请点击合同对比，比较合同内容是否一致')
          this.getList(this.bizId, this.contractType)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 合同对比
    onContractContrast () {
      if (this.contractType === 2) { // 采购
        this.$router.push({
          name: 'purchasecontractContrast',
          query: {
            bizId: this.bizId,
            contractType: this.contractType,
            status: this.$route.query.type,
            type: this.type
          }
        })
      } else if (this.contractType === 1) { // 销售
        this.$router.push({
          name: 'contractContrast',
          query: {
            bizId: this.bizId,
            contractType: this.contractType
          }
        })
      } else if (this.contractType === 3) { // 采购退货
        this.$router.push({
          name: 'purchasecontractContrast',
          query: {
            bizId: this.bizId,
            contractType: this.contractType,
            pcbId: this.$route.query.pcbId,
            pcrId: this.$route.query.pcrId
          }
        })
      } else if (this.contractType === 4) { // 销售退货
        this.$router.push({
          name: 'contractContrast',
          query: {
            bizId: this.bizId,
            contractType: this.contractType,
            id: this.$route.query.id,
            cusId: this.$route.query.cusId
          }
        })
      }
    }
  }
}
</script>
<style lang="scss">
.sealed-contract-uplaod {
  padding: 20px 0;
  width: 100%;
  .el-upload {
    width: 100% !important;
    .el-upload-dragger {
      height: 84px !important;
      width: 100% !important;
    }
    .el-icon-upload {
      margin: 0px !important;
    }
  }
}
</style>
